import React from 'react';
import Lottie from 'lottie-react';
import { SpinLoading } from 'antd-mobile';
import loadingAnimation from '@/assets/json/list_load.json';

const wrapStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
};

// 全页 loading 对齐 Android LoadingPage 的 56.dp。24 是列表里 InlineLoading 的尺寸。
const LOADING_SIZE = 56;

const FallbackSpinner = () => (
  <div style={wrapStyle}>
    <SpinLoading style={{ '--size': `${LOADING_SIZE}px` }} color="primary" />
  </div>
);

class LottieGuard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error('PageLoading lottie failed', error);
  }

  render() {
    if (this.state.hasError) return this.props.fallback;
    return this.props.children;
  }
}

const PageLoading = () => (
  <LottieGuard fallback={<FallbackSpinner />}>
    <div style={wrapStyle}>
      <Lottie
        animationData={loadingAnimation}
        loop
        autoplay
        style={{ width: LOADING_SIZE, height: LOADING_SIZE }}
      />
    </div>
  </LottieGuard>
);

export default PageLoading;
